import { PureLightTheme } from "../../../styles/theme"
import { COLORS } from "../../../styles/variables"

export const CardAuth = {
  margin: '0px auto 24px auto',
  textAlign: 'center',
  padding: '60px 49px 55px 48px',

  [PureLightTheme.breakpoints.down('md')]: {
    padding: '40px 35px 35px 35px',
  }
}

export const BoxAuthHeading = {
  margin: '0px 0px 30px 0px',
}

export const BoxInputs = {
  display: 'flex',
  flexDirection: 'column',
}

export const TextFieldEmail = {
  margin: '0px 0px 20px 0px',
}

export const TextFieldPassword = {
  margin: '0px 0px 43px 0px',
}

export const TextFieldCode = {
  margin: '0px 0px 28px 0px',
}

export const BoxAuthTyp = {
  margin: '0px 0px 43px 0px',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '16px',
  opacity: 0.5,
  color: COLORS.BLACK,
}

export const BoxAuthLink = {
  display: 'inline',
  textDecoration: 'underline',
  fontWeight: 600,
  color: COLORS.BLACK,
  cursor: 'pointer',
}

export const CardReg = {
  textAlign: 'center',
  padding: '40px 49px 41px 48px',
  margin: '0 auto',

  [PureLightTheme.breakpoints.down('md')]: {
    padding: '30px 35px 30px 35px',
  }
}

export const BoxRegTyp = {
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '16px',
  opacity: 0.5,
}

export const ButtonRegister = {
  marginBottom: '12px',
}
